/**
 * Returns a random value from a provided enumerable object.
 */

const getRandomItemFromObject = obj => {
    const keys = Object.keys(obj);
    const totalItems = keys.length;
    const randomIndex = Math.floor(Math.random() * totalItems);

    return obj[keys[randomIndex]];
};

export default getRandomItemFromObject;